import HeroEventDetails from './hero-event-details'

export default HeroEventDetails
